module.exports = __webpack_public_path__ + "img/image1@2x.87196a90.png";